import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import httpService from "@/components/service";
import { createURI } from "@/utils/string";

const path = "plano/caddy/fascias";
// createNamespacedHelper not available on 2.3.1 of vuex
function createNamespacedHelper(path) {
    return {
        mapActions: (...props) => mapActions(path, ...props),
        mapGetters: (...props) => mapGetters(path, ...props),
        mapMutations: (...props) => mapMutations(path, ...props),
        mapState: (...props) => mapState(path, ...props)
    };
}

export const fascias = createNamespacedHelper(path);

const ComponentType = {
    fascias: 9
};

async function loadComponentsByType(type, { page }) {
    const uri = createURI("/components", {
        type,
        offset: page
    });

    return await httpService.get(uri);
}

export default {
    namespaced: true,
    state: {
        fascias: [],
        loading: false,
        page: undefined,
        maxPage: undefined,
        total: undefined,

        error: undefined,
        selectedFasciaId: undefined,
        showFasciaCreator: false
    },
    mutations: {
        startLoading(state, page) {
            state.loading = true;
            state.page = page;
        },
        finishLoading(state) {
            state.loading = false;
        },
        failed(state, error) {
            state.error = error;
        },
        loaded(state, response) {
            state.fascias = response.data;
            state.maxPage = response.meta.totalPage;
            state.total = response.meta.total;
        },
        select(state, fasciaId) {
            if (state.selectedFasciaId === fasciaId) {
                state.selectedFasciaId = undefined;
            } else {
                state.selectedFasciaId = fasciaId;
            }
        },
        insertFascia(state, newFascia) {
            state.fascias = [newFascia, ...state.fascias];
            state.fascias.pop();
        }
    },
    actions: {
        onOpenLibrary({ dispatch }) {
            dispatch("loadPage", 1);
        },
        async loadPage({ commit, state }, page) {
            if (state.page === page || page <= 0 || (state.maxPage && page > state.maxPage)) {
                return;
            }
            try {
                commit("startLoading", page);
                const result = await loadComponentsByType(ComponentType.fascias, { page });
                commit("loaded", result);
                return result;
            } catch (err) {
                console.error(err);
                commit("failed", err);
            } finally {
                commit("finishLoading");
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/plano/caddy/fascias.js